var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".75vw",
    height: ".9vw",
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4169 3.85938H1.5831C1.26106 3.85938 1 4.12576 1 4.45437V9.21647C1 10.2027 1.7835 11.0022 2.75 11.0022H6.25C6.71413 11.0022 7.15925 10.814 7.48744 10.4792C7.81562 10.1443 8 9.69007 8 9.21647V4.45437C8 4.12576 7.73894 3.85938 7.4169 3.85938Z",
    stroke: "#F23D3D",
    strokeOpacity: 0.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59844 2.42862L6.52424 2.27791C6.14057 1.49473 5.35616 1 4.49809 1C3.64002 1 2.85561 1.49473 2.47194 2.27791L2.39844 2.42862H6.59844Z",
    stroke: "#F23D3D",
    strokeOpacity: 0.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8334 6.2389C3.8334 5.96276 3.60954 5.7389 3.3334 5.7389C3.05726 5.7389 2.8334 5.96276 2.8334 6.2389H3.8334ZM2.8334 8.6196C2.8334 8.89574 3.05726 9.1196 3.3334 9.1196C3.60954 9.1196 3.8334 8.89574 3.8334 8.6196H2.8334ZM6.16689 6.2389C6.16689 5.96276 5.94304 5.7389 5.66689 5.7389C5.39075 5.7389 5.16689 5.96276 5.16689 6.2389H6.16689ZM5.16689 8.6196C5.16689 8.89574 5.39075 9.1196 5.66689 9.1196C5.94304 9.1196 6.16689 8.89574 6.16689 8.6196H5.16689ZM6.6001 1.92969C6.32396 1.92969 6.1001 2.15355 6.1001 2.42969C6.1001 2.70583 6.32396 2.92969 6.6001 2.92969V1.92969ZM8.0001 2.92969C8.27624 2.92969 8.5001 2.70583 8.5001 2.42969C8.5001 2.15355 8.27624 1.92969 8.0001 1.92969V2.92969ZM2.4 2.92969C2.67614 2.92969 2.9 2.70583 2.9 2.42969C2.9 2.15355 2.67614 1.92969 2.4 1.92969V2.92969ZM1 1.92969C0.723858 1.92969 0.5 2.15355 0.5 2.42969C0.5 2.70583 0.723858 2.92969 1 2.92969V1.92969ZM3.3334 6.2389H2.8334V8.6196H3.3334H3.8334V6.2389H3.3334ZM5.66689 6.2389H5.16689V8.6196H5.66689H6.16689V6.2389H5.66689ZM6.6001 2.42969V2.92969H8.0001V2.42969V1.92969H6.6001V2.42969ZM2.4 2.42969V1.92969H1V2.42969V2.92969H2.4V2.42969Z",
    fill: "#F23D3D",
    fillOpacity: 0.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.fd59446c3084e9cc5b7e4d42316c054a.svg";
export { ForwardRef as ReactComponent };